import { render, staticRenderFns } from "./PersonalInfoTab1.vue?vue&type=template&id=2e644aea"
import script from "./PersonalInfoTab1.vue?vue&type=script&lang=js"
export * from "./PersonalInfoTab1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e644aea')) {
      api.createRecord('2e644aea', component.options)
    } else {
      api.reload('2e644aea', component.options)
    }
    module.hot.accept("./PersonalInfoTab1.vue?vue&type=template&id=2e644aea", function () {
      api.rerender('2e644aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/PersonalInfoTab1.vue"
export default component.exports